import React from 'react';
import { motion } from 'framer-motion';
import { User, Shield, Zap, HeartHandshake } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-[#0A0A0F] relative border-t border-white/5" data-id="element-14" data-mp="2ps0cyactqjlh">
      <div className="container mx-auto px-6 md:px-12" data-id="element-15" data-mp="2tsahdikyx1y8">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-16" data-mp="2yrx0u9re3efh">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-17" data-mp="33rhvw93fv2mx">
            <div className="aspect-[5/4] rounded-2xl overflow-hidden relative z-10 border border-white/10 bg-[#111118]" data-id="element-18" data-mp="3dhup0ppbk44o">
              <img src="https://cdn.magicpatterns.com/uploads/pdLHkfoY5ShsRkGY42N5hP/Mikes_Pro_Web_2_Pic.png" alt="Mike at work - Owner of Mike's Pro Web Design" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-19" data-mp="3mhr9sg8l8iug" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-transparent to-transparent" data-id="element-20" data-mp="2ls0dybbmr95s"></div>
              <div className="absolute bottom-6 left-6 right-6" data-id="element-21" data-mp="2gqt6kddegbzn">
                <div className="bg-black/60 backdrop-blur-md border border-white/10 p-4 rounded-xl" data-id="element-22" data-mp="2cpr9a231ma0b">
                  <h3 className="text-white font-heading font-bold text-xl" data-id="element-23" data-mp="27shl0pre44e2"></h3>
                  <p className="text-blue-400 text-sm font-medium" data-id="element-24" data-mp="34i8ceg4dxbfn"></p>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-blue-600/20 rounded-full blur-2xl" data-id="element-25" data-mp="30ihhc07ts95b"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-500/20 rounded-full blur-2xl" data-id="element-26" data-mp="2qqbpqrlhjtqn"></div>
            <div className="absolute top-1/2 -right-12 transform -translate-y-1/2 w-24 h-48 border border-white/5 rounded-full hidden lg:block" data-id="element-27" data-mp="3o5ftwmstqwxy"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-28" data-mp="663teliy5fu2">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-29" data-mp="3ti4o9k208yih">
              Your Dedicated Web Partner,{' '}
              <span className="text-gradient" data-id="element-30" data-mp="1cr4eaacv70s">Not Just an Agency</span>
            </h2>
            <p className="text-lg mb-8 leading-relaxed text-[#FFFFFF]" data-id="element-31" data-mp="3jmtcnalw87ey">
              Hi, I'm Mike. I run a one-man web design agency dedicated to
              helping businesses succeed online. When you work with me, you're
              not passed off to a junior developer or an account manager. You
              work directly with the owner from the first discovery call to the
              final launch.
            </p>

            <div className="space-y-6" data-id="element-32" data-mp="1cu0kcmu9zgxc">
              <div className="flex gap-4" data-id="element-33" data-mp="1cszcer8k3aju">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-400 border border-blue-500/20" data-id="element-34" data-mp="2xcb3wgjon8zk">
                  <User size={24} data-id="element-35" data-mp="2tcar10c8f5um" />
                </div>
                <div data-id="element-36" data-mp="371ur1yefhp08">
                  <h4 className="text-white font-bold text-lg mb-1" data-id="element-37" data-mp="373630li1232f">
                    Owner-Operated
                  </h4>
                  <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-38" data-mp="32a37i7towjjl">
                    Direct communication and accountability. I personally
                    design, build, and launch every project.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-39" data-mp="3pzxiejug7y17">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-400 border border-blue-500/20" data-id="element-40" data-mp="3pyw4m7m1sxfs">
                  <Shield size={24} data-id="element-41" data-mp="1vo0madl2a3zt" />
                </div>
                <div data-id="element-42" data-mp="1qnw6yqvw3fb6">
                  <h4 className="text-white font-bold text-lg mb-1" data-id="element-43" data-mp="1qoo1dydr36zv">
                    Reliability & Attention to Detail
                  </h4>
                  <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-44" data-mp="1t29qwp5fjapm">
                    I treat your business like my own. Every pixel is
                    considered, and every line checked for 100% satisfaction.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-45" data-mp="271sl0e1eolix">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-400 border border-blue-500/20" data-id="element-46" data-mp="19ek7b57ncgrh">
                  <HeartHandshake size={24} data-id="element-47" data-mp="1ee6fh08mb6tf" />
                </div>
                <div data-id="element-48" data-mp="1jcgc7f9zqfh5">
                  <h4 className="text-white font-bold text-lg mb-1" data-id="element-49" data-mp="1jbybo6gapf3f">
                    Personalized Service
                  </h4>
                  <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-50" data-mp="1o59ja9sxlzwe">
                    Custom solutions tailored to your specific goals.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}